/** Paper-boat hero background — served from /public/videos (WebM, ~4.3 MB). */
export const MAIN_HERO_VIDEO_SRC = "/videos/animated-paper-boat.webm";
